export function isGuestRiderForTeam(rider, teamId = "") {
  if (!rider) return false;
  if (Boolean(rider.is_guest_for_team)) return true;

  const normalizedTeamId = String(teamId || rider.context_team_id || "");
  const guestForTeamId = String(rider.guest_for_team_id || "");
  const clubTeamId = String(rider.club_team_id || rider.team_id || "");

  if (!guestForTeamId || !normalizedTeamId) return false;
  return guestForTeamId === normalizedTeamId && clubTeamId && clubTeamId !== normalizedTeamId;
}
